import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Popover } from '@material-ui/core';
import {
  Colors,
  DownloadFile,
  FindSuccess,
  Images, PermissionsList, RolePermission, SavePage,
  useModal, userType,
} from 'utils';
import { httpRequestsOnLoadActions, httpRequestsOnSuccessActions, loadActions } from 'store';
import { CustomDeleteModal } from '../../../modals';
import { MinLoader, VoidButton, VoidedButton } from 'components';
import { transactionStatusEnums, TxnType } from './constants';
import { authService } from '../../../../store/loads/loads.service';
import { useHistory } from 'react-router-dom';
import { AddTransactionModal } from './addTransactionModal';
import { EditTransactionDescription } from './editTransactionDescription';

const VOID_TYPE = 'TRANSACTION_VOID';
const DELETE_TYPE = 'DELETE_TRANSACTION';

export const TransactionMoreAction = ({
                                        item,
                                        document,
                                        handleDeleteDocument,
                                        deleteDocAction,
                                        changeStatusAction,
                                      }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const { open, close } = useModal();
  const success = FindSuccess(changeStatusAction);
  const openPopover = Boolean(anchorEl);
  const id = openPopover ? 'simple-popover' : undefined;
  const history = useHistory();
  const pushInfo = history?.location?.state;

  const toggleSettings = (event) => {
    setAnchorEl(event ? event.currentTarget : null);
  };

  useEffect(() => {
    if (success?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(changeStatusAction));
      toggleSettings();
      close();
    }
  }, [success]);

  const checkVoidBtn = (info) => {
    return info?.status === transactionStatusEnums?.APPLIED &&
      userType === 'ADMIN' && RolePermission([PermissionsList.ALL_ACCESS?.code, PermissionsList.TRANSACTION_VOID_BUTTON?.code]) &&
      info?.type !== TxnType.QUICKPAY_REVERSAL && info?.type !== TxnType.QUICKPAY &&
      info?.type !== TxnType.CUSTOMERPAYMENT && info?.type !== TxnType.CARRIERPAYMENT &&
      info?.type !== TxnType.FUEL_FEE && info?.type !== TxnType.LPF_AGENT_CHARGE &&
      info?.type !== TxnType.LPF_AGENT_CREDIT && info?.type !== TxnType.LPF_CARRIER_CHARGE &&
      info?.type !== TxnType.LPF_CARRIER_CREDIT &&
      info?.type !== TxnType.RESERVE &&
      info?.type !== TxnType.RESERVE_RELEASE &&
      info?.type !== TxnType.RESERVE_CHARGE &&
      info?.type !== TxnType.COLLECTIONAPPLIED &&
      info?.type !== TxnType.COLLECTION_TRANSFERRED;
  };

  const handleVoid = (info) => {
    if (info?.status === transactionStatusEnums?.VOID) {
      return <VoidedButton />;
    } else if (checkVoidBtn(info)) {
      return  open(
        <CustomDeleteModal
          actionType={VOID_TYPE}
          type={'void'}
          text={'Void Transaction?'}
          handleDel={() => handleVoidAction(info)}
        />,
      );
    } else {
      return '  ';
    }
  };

  const handleVoidAction = async () => {
    dispatch(httpRequestsOnSuccessActions.removeSuccess(VOID_TYPE));
    dispatch(httpRequestsOnLoadActions.appendLoading(VOID_TYPE));
    try {
      await authService.editLoadTransactionsService(item?.load, item?.id);
      dispatch(loadActions.getLoadById(item?.load, 'noLoad'));
      close();
      dispatch(httpRequestsOnLoadActions.removeLoading(VOID_TYPE));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(VOID_TYPE));
      SavePage(history, pushInfo, { ...pushInfo });
    } catch (e) {
      close();
      dispatch(httpRequestsOnLoadActions.removeLoading(VOID_TYPE));
      SavePage(history, pushInfo, { ...pushInfo });
    }
  };

  const handleDeleteTxns = async () => {
    dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_TYPE));
    dispatch(httpRequestsOnLoadActions.appendLoading(DELETE_TYPE));
    try {
      await authService.deleteTransactionsService(item?.load, item?.id);
      dispatch(loadActions.getLoadById(item?.load, 'noLoad'));
      close();
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_TYPE));
      dispatch(httpRequestsOnSuccessActions.appendSuccess(DELETE_TYPE));
      SavePage(history, pushInfo, { ...pushInfo });
    } catch (e) {
      close();
      dispatch(httpRequestsOnLoadActions.removeLoading(DELETE_TYPE));
      SavePage(history, pushInfo, { ...pushInfo });
    }
  };

  return (
    <div className="document-settings-wrapper">
      <button
        className="document-settings-button"
        onClick={toggleSettings}
      >
        <img src={Images.more} alt="icon" />
      </button>
      <Popover
        id={id}
        open={openPopover}
        anchorEl={anchorEl}
        onClose={() => toggleSettings()}
        className="document-settings-popover-wrapper"
        classes={{
          paper: 'txns-settings-popper',
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        sx={{
          '& .MuiPaper-root': {
            width: '150px!important',
          },
        }}
      >
        <div className="document-settings-popper-wrapper">
          <div className="document-settings-popper-actions-wrapper">
            <div
              className="document-settings-popper-actions-item"
              onClick={() => {
                toggleSettings();
                if(item?.status === transactionStatusEnums?.PENDING) {
                  open(<AddTransactionModal info={item} txns={item}/>);
                }else {
                  open(<EditTransactionDescription info={item} />)
                }
              }}
            >
              <div className="document-settings-popper-actions-img" style={{ padding: '4px' }}>
                <img src={Images.edit} alt="edit" />
              </div>
              <p className="document-settings-popper-text">Edit</p>
            </div>
            {checkVoidBtn(item) &&
              <div
                className="document-settings-popper-actions-item"
                onClick={() => handleVoid(item)}
              >
                <div className="document-settings-popper-actions-img" style={{ padding: '2px 3px 4px 4px' }}>
                  <img src={Images.voidTxns} alt="download" />
                </div>
                <p className="document-settings-popper-text">Void</p>
              </div>
            }
            {item?.status === transactionStatusEnums?.PENDING &&
              <div
                className="document-settings-popper-actions-item"
                onClick={() => {
                  toggleSettings();
                  open(
                    <CustomDeleteModal
                      actionType={DELETE_TYPE}
                      text="Delete File?"
                      info={document?.name}
                      handleDel={handleDeleteTxns}
                      afterSuccess={() => close()}
                    />);
                }}
              >
                <div className="document-settings-popper-actions-img" style={{ padding: '4px 5px' }}>
                  <img src={Images.trashIcon} alt="delete" />
                </div>

                <p className="document-settings-popper-text">Delete</p>
              </div>
            }
          </div>
        </div>
      </Popover>
    </div>
  );
};

